import { Eigenbauleistungen } from "@/model/Eigenbauleistungen";
import { Sanierungsdaten } from "@/model/Sanierungsdaten";
import { Gewerbe } from "@/model/Gewerbe";

export class Gebaeudedaten {
  gebaeudetyp = "";
  gebaeudesubtyp = "";
  gebaeudenutzung = "";
  vermietet: boolean | null;
  leerstand: number | null;
  gewerbeVorhanden: boolean | null;
  gewerbeAnzahl: number | null;
  baujahr: number | null;
  bausumme: number | null;
  fertighaus: boolean | null;
  bauart = "";
  dachbelag = "";
  denkmalschutz = false;
  denkmalschutzManuell = false;
  dachvariante = "";
  anzahlVollgeschosse: number | null;
  wohnflaeche: number | null;
  kellerVorhanden: boolean | null;
  wohnflaecheKeller: number | null;
  nebengebaeudeVorhanden: boolean | null;
  wohnflaecheNebengebaeude: number | null;
  parkplaetzeVorhanden: boolean | null;
  anzahlGaragen: number | null;
  anzahlCarports: number | null;
  rueckstausicherungVorhanden = false;
  photovoltaikVorhanden: boolean | null;
  photovoltaikBaujahr: number | null;
  photovoltaikLeistung: number | null;
  photovoltaikStandort = "";
  photovoltaikInstallationFachfirma = false;
  schwimmbadVorhanden: boolean | null;
  artDesBauvorhabens = "";
  wandAnWand = false;
  nachbargebaeudeImEigentum: boolean | null;
  durchDritteBewohnt: boolean | null;
  unbebautesGruendstueck: boolean | null;
  flaecheUnbebautesGrundstueck: number | null;
  anzahlWohnungen: number | null;
  anzahlStellplaetzeGaragen: number | null;
  gewerbeflaecheGesamt: number | null;
  alleineigentuemer: boolean | null;
  miteigentuemerTyp = "";
  immobilieArt = "";
  eek = "";
  eekManuell = "";
  eekHash = "";
  eigenbauleistungen = new Eigenbauleistungen();
  sanierungsdaten = new Sanierungsdaten();
  gewerbeListe: Gewerbe[];

  //Frontend-spezifische Erweiterungen
  besondereGruendungsmassnahmen: boolean | null;
  imGrundwasserErbaut: boolean | null;

  constructor() {
    this.vermietet = null;
    this.leerstand = null;
    this.gewerbeVorhanden = null;
    this.gewerbeAnzahl = null;
    this.baujahr = null;
    this.bausumme = null;
    this.fertighaus = null;
    this.anzahlVollgeschosse = null;
    this.wohnflaeche = null;
    this.kellerVorhanden = null;
    this.wohnflaecheKeller = null;
    this.nebengebaeudeVorhanden = null;
    this.wohnflaecheNebengebaeude = null;
    this.parkplaetzeVorhanden = null;
    this.anzahlGaragen = null;
    this.anzahlCarports = null;
    this.photovoltaikVorhanden = null;
    this.photovoltaikBaujahr = null;
    this.photovoltaikLeistung = null;
    this.schwimmbadVorhanden = null;
    this.nachbargebaeudeImEigentum = null;
    this.durchDritteBewohnt = null;
    this.unbebautesGruendstueck = null;
    this.flaecheUnbebautesGrundstueck = null;
    this.anzahlWohnungen = null;
    this.anzahlStellplaetzeGaragen = null;
    this.gewerbeflaecheGesamt = null;
    this.alleineigentuemer = null;
    this.gewerbeListe = [new Gewerbe(), new Gewerbe(), new Gewerbe(), new Gewerbe()];
    this.besondereGruendungsmassnahmen = null;
    this.imGrundwasserErbaut = null;
  }
}
